import React from "react";
import { Lock } from "lucide-react";
import { cn } from "../../../lib/cn";

/**
 * ToggleGroup — ui-v2.5. Selector exclusivo de 2–3 opciones. Pastilla sobre fondo hundido.
 * Especificación: ui-v2.5-catalogo-componentes.html · sección ToggleGroup.
 * NO es el ToggleGroup de ui-v2 (aquel usa `active` por item). CONTROLADO: `value` + `onChange`.
 *
 * <ToggleGroup value={v} onChange={setV}>
 *   <ToggleItem value="int" label="Internos" icon={UserRound} count={4} />
 *   <ToggleItem value="col" label="Colaboradores" disabled />   // muestra candado
 * </ToggleGroup>
 */

export function ToggleItem({ label, icon: Icon, count, disabled, active, onSelect }) {
  return (
    <button
      type="button"
      aria-pressed={!!active}
      disabled={disabled}
      onClick={onSelect}
      className={cn(
        "inline-flex items-center gap-2 rounded-v25-md px-4 py-2 text-sm font-medium transition-colors",
        "focus-visible:outline-none focus-visible:shadow-v25-focus",
        disabled
          ? "cursor-not-allowed text-v25-ink-700 opacity-40"
          : active
          ? "bg-v25-brand-800 text-white"
          : "text-v25-ink-700 hover:bg-v25-surface-sunken"
      )}
    >
      {disabled ? <Lock className="h-3.5 w-3.5" /> : Icon ? <Icon className="h-4 w-4" /> : null}
      {label}
      {count != null && (
        <span className={cn("rounded px-1.5 py-0.5 text-[10px]", active ? "bg-white/20 text-white" : "bg-v25-line text-v25-ink-700")}>
          {count}
        </span>
      )}
    </button>
  );
}

export function ToggleGroup({ value, onChange, children, className }) {
  return (
    <div className={cn("inline-flex w-fit items-center gap-1 rounded-v25-lg border border-v25-line bg-v25-surface p-1", className)}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child) || child.type !== ToggleItem) return child;
        return React.cloneElement(child, {
          active: child.props.value === value,
          onSelect: () => onChange?.(child.props.value),
        });
      })}
    </div>
  );
}
